import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import ContactBar from '@/components/ContactBar';
import Footer from '@/components/Footer';
import HomePage from '@/pages/HomePage';
import ServicesPage from '@/pages/ServicesPage';
import TestCatalogPage from '@/pages/TestCatalogPage';
import PatientResourcesPage from '@/pages/PatientResourcesPage';
import AppointmentPage from '@/pages/AppointmentPage';
import ContactPage from '@/pages/ContactPage';
import FAQPage from '@/pages/FAQPage';
import ServiceDetailPage from '@/pages/ServiceDetailPage';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white flex flex-col">
        <ContactBar />
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/services/:serviceId" element={<ServiceDetailPage />} />
            <Route path="/test-catalog" element={<TestCatalogPage />} />
            <Route path="/patient-resources" element={<PatientResourcesPage />} />
            <Route path="/appointment" element={<AppointmentPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/faq" element={<FAQPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
